import { html } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';
import componentStyles from './alphabet-listing.css.lit.ts';
import QueryComponent from '../../base/query-component/QueryComponent.js';

export default class AlphabetListing extends QueryComponent {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      active: { type: String },
      listingContainer: { type: Object },
      description: { type: String },
      listings: { type: Array },
      noResults: { type: String },
      setContainerHeight: { type: String },
      title: { type: String },
    };
  }

  constructor() {
    super();
    this.active = 'a';
    this.setContainerHeight = 'auto';

    window.addEventListener('hashchange', e => {
      const newHash = e.newURL.substring(e.newURL.indexOf('#') + 1);
      this._scrollTo(newHash);
    });

    window.addEventListener('load', () => {
      const [listingContainer] = document
        .querySelectorAll('hf-alphabet-listing')[0]
        .shadowRoot.querySelectorAll('.alphabet-listing__listings-container');
      const cards = document
        .querySelectorAll('hf-alphabet-listing')[0]
        .shadowRoot.querySelectorAll('hf-alphabet-card');
      const abHeight =
        cards[0].getBoundingClientRect().height +
        cards[1].getBoundingClientRect().height;

      this.setContainerHeight =
        window.innerHeight - 350 > abHeight
          ? abHeight
          : window.innerHeight - 350;

      listingContainer.addEventListener('scroll', () => {
        cards.forEach(card => {
          const rect = card.getBoundingClientRect();
          if (rect.top <= 190) {
            this.active = card.letter;
          }
        });
      });
    });
  }

  _scrollTo(hash) {
    const [selectedCard] = document
      .querySelectorAll('hf-alphabet-listing')[0]
      .shadowRoot.querySelectorAll(`hf-alphabet-card#${hash}`);

    selectedCard.scrollIntoView();
  }

  render() {
    return html`
      <div class="alphabet-listing__wrapper">
        <hf-alphabet-nav
          description=${this.description}
          active="${this.active}"
        ></hf-alphabet-nav>
        <div
          class="alphabet-listing__listings-container"
          style=${styleMap({
            height: `${this.setContainerHeight}px`,
          })}
        >
          ${this.listings.map(listing => {
            return html`
              <hf-alphabet-card
                id="alphabet-card--${listing.letter}"
                letter="${listing.letter}"
                .links="${listing.links}"
                noResults="${this.noResults}"
              ></hf-alphabet-card>
            `;
          })}
        </div>
      </div>
    `;
  }
}
customElements.define('hf-alphabet-listing', AlphabetListing);
